import { render, staticRenderFns } from "./UserStatusModal.vue?vue&type=template&id=15467d08&scoped=true&"
import script from "./UserStatusModal.vue?vue&type=script&lang=js&"
export * from "./UserStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./UserStatusModal.vue?vue&type=style&index=0&id=15467d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15467d08",
  null
  
)

export default component.exports